import React from "react";
import { Box, Tooltip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export function UnreadThreadBadge({ count }) {
  const theme = useTheme();

  if (!count || count <= 0) return null;

  const messageLabel =
    count === 1 ? "1 nuevo mensaje" : `${count} nuevos mensajes`;

  return (
    <Tooltip title={messageLabel} arrow>
      <Box
        sx={{
          minWidth: 18,
          height: 18,
          borderRadius: "20px",
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "0.625rem",
          fontWeight: 700,
          lineHeight: 1,
          fontVariantNumeric: "tabular-nums",
          px: 0.5,
          flexShrink: 0,
        }}
      >
        {count}
      </Box>
    </Tooltip>
  );
}
